<div class="creditScoreItem" [ngClass]="customClass">
  <div class="gaugeWrapper">
    <apx-chart [series]="riskChartOptions.series" [chart]="riskChartOptions.chart"
      [plotOptions]="riskChartOptions.plotOptions ||{}" [stroke]="riskChartOptions.stroke ||{}"
      [fill]="riskChartOptions.fill ||{}" [dataLabels]="riskChartOptions.dataLabels ||{}"
      [labels]="riskChartOptions.labels">
    </apx-chart>
  </div>

</div>